// extracted by mini-css-extract-plugin
export default {"tableContainer":"categories_tableContainer__DlDke"};